import { DocumentCardProps } from '../interface/interface';
import { PaperClipIcon } from '@heroicons/react/24/outline';

export function DocumentCard(props: DocumentCardProps) {
  return (
    <>
      {props.item.length ? (
        <ul
          role="list"
          className="divide-y divide-gray-100 rounded-md border border-gray-200"
        >
          {props.item.map((item, index) => (
            <li
              key={index}
              className="flex items-center justify-between py-4 pl-4 pr-5 text-sm/6"
            >
              <div className="flex w-0 flex-1 items-center">
                <PaperClipIcon
                  aria-hidden="true"
                  className="size-5 shrink-0 text-gray-400"
                />
                <div className="ml-4 flex min-w-0 flex-1 gap-2">
                  <span className="truncate font-medium">{item.name}</span>
                  <span className="shrink-0 text-gray-400">{item.size}</span>
                </div>
              </div>
              <div className="ml-4 shrink-0">
                <a
                  href="#"
                  className="font-medium text-darkred-600 hover:text-indigo-500"
                  onClick={() => item.onDelete()}
                >
                  Delete
                </a>
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <></>
      )}
    </>
  );
}
